// SPDX-License-Identifier: LicenseRef-Proprietary

import React from 'react';
import type { AnalysisProgress } from '../hooks/useAnalysisProgress';

export interface ProgressIndicatorProps {
  progress: AnalysisProgress;
  className?: string;
}

export const ProgressIndicator: React.FC<ProgressIndicatorProps> = ({
  progress,
  className = ''
}) => {
  const timeRemainingSeconds = progress.estimatedTimeRemaining
    ? Math.ceil(progress.estimatedTimeRemaining / 1000)
    : null;

  const formatTimeRemaining = (seconds: number): string => {
    if (seconds < 60) return `${seconds}s`;
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return remainingSeconds > 0 ? `${minutes}m ${remainingSeconds}s` : `${minutes}m`;
  };

  return (
    <div className={`analysis-progress ${className}`}>
      <div className="analysis-progress__header">
        <span className="analysis-progress__title">Processing analysis</span>
      </div>

      <div className="analysis-progress__bar-container">
        <div className="analysis-progress__bar">
          <div
            className="analysis-progress__fill analysis-progress__fill--indeterminate"
            role="progressbar"
            aria-label="Analysis in progress"
          />
        </div>
      </div>

      <div className="analysis-progress__status">
        <span className="analysis-progress__current">
          Processing your selected papers...
        </span>
        {timeRemainingSeconds && timeRemainingSeconds > 0 && (
          <span className="analysis-progress__time">
            ~{formatTimeRemaining(timeRemainingSeconds)} remaining
          </span>
        )}
      </div>
    </div>
  );
};
